import React from "react";
import { Popover, PopoverProps } from "antd";
import { Text } from "@chakra-ui/react";

interface WarningPopoverProps {
  title: string;
  popoverProps?: Omit<PopoverProps, "content">;
  children: React.ReactNode;
  active?: boolean;
}
function WarningPopover({
  title,
  popoverProps,
  children,
  active = true,
}: WarningPopoverProps): JSX.Element {
  if (active) {
    return (
      <Popover
        getPopupContainer={(node: any) => node.parentNode}
        trigger="hover"
        {...popoverProps}
        content={() => <Text>{title}</Text>}
      >
        {children}
      </Popover>
    );
  }

  return <>{children}</>;
}

export default WarningPopover;
